import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {RangeFeature} from "../../model/catalog/catalog.model";
import {ValidatorService} from "../../service-utils/validator-service";
import {TranslateService} from "@ngx-translate/core";
import {CatalogApiService} from "../../api/catalog-api.service";

@Component({
  selector: 'app-validation-warning',
  templateUrl: './validation-warning.component.html',
  styleUrls: ['./validation-warning.component.scss']
})
export class ValidationWarningComponent implements OnInit, OnChanges{

  @Input() backSideId: number;
  @Input() lensFamilyId: number;
  @Input() additionalOptions;

  limits = [];
  names: Array<string> = [];

  constructor(private validatorService: ValidatorService,
              private translateService: TranslateService,
              private catalogApiService: CatalogApiService
              ) {}

  ngOnInit() {
    this.getLimits();
  }

  ngOnChanges() {
    this.getLimits();
  }

  getLimits() {
    let result = [];
    if (this.lensFamilyId) {
      this.catalogApiService.getLensDetails(this.lensFamilyId).subscribe(details => {
        for(let field of Object.values(details.features.default)) {
          if (field.name.includes('Radius')) {
            let feature = field as RangeFeature;
            result.push({name: field.name, rangeMin: feature.rangeMin, rangeMax: feature.rangeMax});
          }
        }
      });
    }
    this.limits = result;
  }

  getFieldFormatted(key: string) {
    let field: string = 'parameters';
    this.translateService.get('common.features.' + key).subscribe(value => field = value);
    return {
      field: field
    }
  }

  getKeys(): Array<string>{
    return Array.from(this.additionalOptions.keys());
  }

  inHiddenLimits(name: string): boolean {
    let result: boolean = false;
    let value: number = this.additionalOptions.get(name).replace(',','.');
    for (let limit of this.limits) {
      if (limit.name == name) {
        if ((value < limit.rangeMin) && (value >= (limit.rangeMin - 5))) {
          result = true;
        }
        if ((value > limit.rangeMax) && (value <= (limit.rangeMax + 5))) {
          result = true;
        }
      }
    }
    return result;
  }
}
